import { ILiveRegionsResponse } from '../../models/LiveRegionsResponse';
import { cloudLiveResources } from '../builders/cloudLiveResources';
import { ILiveStack } from '../../hooks/useLiveApi';
import { ILiveStackAccessResponse } from '../../models/LiveStackAccessResponse';
import { getUseResource } from '../resource';
import { UUID } from '../../types/uuid';

export interface ICreateLiveStackPayload {
  userUuid: UUID;
  organizationUuid: UUID;
  cameraId: number;
  subscriptionPlan: number;
  protocol: 'SRT';
  capacityReservation: boolean;
  allowListCIDR?: string;
}

export const apiCloudLive = {
  useGetAllStacksList: getUseResource(cloudLiveResources.getAllLiveStacks, (body): ILiveStack[] => body),

  useGetAllStacksListSilent: getUseResource(
    cloudLiveResources.getAllLiveStacks,
    (body): ILiveStack[] => body,
    void 0,
    void 0,
    void 0,
    { indicateLoading: false }
  ),

  useGetOrganizationStacksList: getUseResource(
    cloudLiveResources.getOrganizationLiveStacks,
    (body): ILiveStack[] => body
  ),

  useGetOrganizationStacksListSilent: getUseResource(
    cloudLiveResources.getOrganizationLiveStacks,
    (body): ILiveStack[] => body,
    void 0,
    void 0,
    void 0,
    { indicateLoading: false }
  ),

  useCreateLiveStack: getUseResource(
    cloudLiveResources.createOrganizationLiveStack,
    (body): void => body,
    (params, payload: ICreateLiveStackPayload) => payload
  ),

  useRemoveLiveStack: getUseResource(cloudLiveResources.removeOrganizationLiveStack, (body): void => body),

  useStartLiveStack: getUseResource(cloudLiveResources.startLiveStack, (body): void => body),

  useStopLiveStack: getUseResource(cloudLiveResources.stopLiveStack, (body): void => body),

  useGetAccessData: getUseResource(
    cloudLiveResources.getOrganizationLiveStackAccess,
    (body): ILiveStackAccessResponse => body
  ),

  useGetAccessDataSilent: getUseResource(
    cloudLiveResources.getOrganizationLiveStackAccess,
    (body): ILiveStackAccessResponse => body,
    void 0,
    void 0,
    void 0,
    { indicateLoading: false }
  ),

  useGetRegions: getUseResource(cloudLiveResources.getLiveRegions, (body): ILiveRegionsResponse => body),
};
